/**
*  Date    : 2021/05/14
*  Author  : lbb1811
*  Declare : context
*/
import React, { useContext } from 'react';

const Context = React.createContext({});

export default Context;

/** userLabel Context */
export function useLableContext() {
  return useContext(Context);
}
